import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  color: #c1c1c1;
  font-size: 14px;
  text-align: center;
  min-height: 100px;
  width: 100%;
`;
